"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUrssafCompensatoryProduct = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../utils/big-numbers");
var compute_tax_rate_1 = require("../tax-rate/compute-tax-rate");
var types_1 = require("../types");
var initialize_price_values_1 = require("./initialize-price-values");
var computePriceForProductsIncludedInUrssaf = function (products) {
    return products.reduce(function (acc, product) {
        if (product.tags.every(function (tag) { return tag !== types_1.ProductTag.ExcludedFromUrssaf; })) {
            acc = acc.plus(product.totalPriceNotRounded.totalInclTaxWithDiscount);
        }
        return acc;
    }, big_numbers_1.big0);
};
var generateUrssafCompensatoryProduct = function (totalPrice, products, totalAdmissionsPrice, totalRoyaltiesPrice, urssafTargetAmountNumber) {
    var URSSAF_COMPENSATORY_PRODUCT_VAT_RATE = 1000;
    var value;
    // There must be at least one grant used so we can use the urssaf compensatory product
    var atLeastOneGrantUsed = totalPrice.totalInclTaxWithRemise.comparedTo(totalPrice.totalInclTaxWithDiscount) === 1;
    if (!atLeastOneGrantUsed) {
        value = big_numbers_1.big0;
    }
    else if (urssafTargetAmountNumber) {
        var priceForProductsIncludedInUrssaf = computePriceForProductsIncludedInUrssaf(products);
        var totalPriceDiscountedInclTaxWithoutUrssaf = priceForProductsIncludedInUrssaf
            .plus(totalAdmissionsPrice.totalInclTaxWithDiscount)
            .plus(totalRoyaltiesPrice.totalInclTaxWithDiscount);
        var urssafTargetAmount = new bignumber_js_1.default(urssafTargetAmountNumber);
        value =
            urssafTargetAmount.comparedTo(totalPriceDiscountedInclTaxWithoutUrssaf) === 1
                ? urssafTargetAmount.minus(totalPriceDiscountedInclTaxWithoutUrssaf)
                : big_numbers_1.big0;
    }
    else {
        value = big_numbers_1.big0;
    }
    var inclTax = value;
    var exclTax = (0, compute_tax_rate_1.computeExclTaxFromInclTax)(inclTax, URSSAF_COMPENSATORY_PRODUCT_VAT_RATE);
    return {
        label: types_1.ProductLabel.compensatoryProduct,
        totalPriceNotRounded: {
            totalInclTax: inclTax,
            totalExclTax: exclTax,
            totalInclTaxWithDiscount: inclTax,
            totalExclTaxWithDiscount: exclTax,
            totalInclTaxWithRemise: inclTax,
            totalExclTaxWithRemise: exclTax,
        },
        totalPriceRounded: (0, initialize_price_values_1.initPricesRounded)(),
        taxRate: URSSAF_COMPENSATORY_PRODUCT_VAT_RATE,
    };
};
exports.generateUrssafCompensatoryProduct = generateUrssafCompensatoryProduct;
